import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { Lockbox } from '@/modules/employer/components/Lockbox/lockbox.types';
import { formatCurrency } from '@/utils';

interface Props {
  lockbox?: Lockbox;
}

const useLockboxIReturnedCheckFields = ({ lockbox }: Props) => {
  const ocrDetails = lockbox?.ocr?.details;
  const claimIds = lockbox?.ocr?.claimIds;

  const lockboxIReturnedCheckFields: Field[] = useMemo(() => [
    {
      type: FieldTypes.Text,
      name: 'checkNumber',
      label: 'Check number',
      value: ocrDetails?.checkNumber || EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'payTo',
      label: 'Pay to',
      value: ocrDetails?.payTo || EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'claimId',
      label: 'Claim ID',
      value: claimIds?.length ? claimIds.join(', ') : EMPTY_FIELD_VALUE,
    },
    {
      type: FieldTypes.Text,
      name: 'amount',
      label: 'Amount',
      value: typeof ocrDetails?.amount === 'number'
        ? formatCurrency(ocrDetails.amount) || EMPTY_FIELD_VALUE
        : EMPTY_FIELD_VALUE,
    },
  ], [ocrDetails, claimIds]);

  return {
    lockboxIReturnedCheckFields,
  };
};

export default useLockboxIReturnedCheckFields;
